import { render, staticRenderFns } from "./Tasks.vue?vue&type=template&id=13647f93&scoped=true&"
import script from "./Tasks.ts?vue&type=script&lang=ts&"
export * from "./Tasks.ts?vue&type=script&lang=ts&"
import style0 from "./Tasks.scss?vue&type=style&index=0&id=13647f93&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13647f93",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VContainer,VIcon,VRow,VSheet,VTooltip})
